import { Card, CardContent } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";

function OrderNotesDialog({ isOpen, onClose, order }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[520px] ">
        <DialogTitle className="px-4 pt-4 text-center font-medium text-white">
          Notes
        </DialogTitle>
        <div className="px-4 pb-4 pt-4">
          <Card className="border-0 bg-[#2d2d2d] text-white shadow-none">
            <CardContent className="p-4">
              <p className="mb-2 text-xs text-cyellow">
                Cooking Time: {order?.cookingTime || 0} Min
              </p>
              <p className="text-sm leading-6 text-cwhite3">
                {order?.notes || "Not provided"}
              </p>
            </CardContent>
          </Card>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OrderNotesDialog;
